"use client";
import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

export default function QBosonBuildsTrustAnimation() {
  const ImageParagraphData = {
    heading: "Q-boson build trust in every salesforce release",
    description: ["Us Patent", "India Patent"],
    images: [
      { name: "US Patent", src: "/images/US-Petant.svg", alt: "image alt" },
      {
        name: "Indian Patent",
        src: "/images/India-Petant.svg",
        alt: "image alt",
      },
    ],
  };

  const imageRefs = useRef<(HTMLDivElement | null)[]>([]);

  // useEffect(() => {
  //   gsap.fromTo(
  //     imageRefs.current,
  //     { scale: 0, opacity: 0 },
  //     {
  //       scale: 1,
  //       opacity: 1,
  //       stagger: 0.2,
  //       duration: 1.5,
  //       ease: "power3.out",
  //       toggleActions: "restart none none reverse",
  //       scrollTrigger: {
  //         trigger: imageRefs.current,
  //         toggleActions: "restart none none reverse",
  //         start: "top 90%",
  //       },
  //     }
  //   );
  // }, []);

  return (
    <>
      {/* <div className="flex justify-center gap-20 pb-10 sm:pb-0   items-center">
        {ImageParagraphData.images.map((image, index) => {
          return (
            <div
              className="flex justify-center gap-2 flex-col items-end"
              key={index}
              ref={(el) => { imageRefs.current[index] = el; }}
            >
              <img
                className="w-24 sm:w-24 lg:w-32 h-auto"
                alt={image.alt}
                src={image.src}
              />

              <p className={`${image.name == "US Patent" ? "me-3" : ""}`}>
                {image.name}
              </p>
            </div>
          );
        })}
      </div> */}
    </>
  );
}
